import React from 'react';
import GeneralDialog from '../../internal-components/GeneralDialog';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import useTranslations from '../../hooks/useTranslations';
import PublicIcon from '@material-ui/icons/Public';
import LockIcon from '@material-ui/icons/Lock';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import _Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import { FORM_TYPE } from '../engine/FormBuilderShareAccessSettingsDialogEngine';
import Animation from '../Animation';
import _Select from 'react-select';
import { MultiValue } from './GroupsAndUsersInputBoxView';
import InputBase from '../form/InputBase';
import { DisableWrapper } from './FormBuilderShareView';

const BombaButton = styled(Button)`
  && {
    margin-top: 0.8rem;
    text-transform: none;
    width: 100%;
    justify-content: left;
  }

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 0.8rem;
  }
`;

const Container = styled(SimpleFlexContainer)`
  // margin-top: 0.8rem;
`;

const ButtonGrid = styled(SimpleFlexContainer)`
  text-align: left;
`;

const Divider = styled(_Divider)`
  margin: 2rem 0 !important;
`;

const H2 = styled.h2`
  margin: 0 0 1.2rem;
  font-size: 20px;
`;

const LimitAccessSpan = styled.span`
  display: flex;
  margin-bottom: 0.8rem;
`;

const Select = styled(_Select)`
  && {
    font-size: 14px;
    margin-bottom: 1rem;
  }
`;

const FormBuilderShareAccessSettingsDialogView = props => {
  const t = useTranslations();

  return (
    <GeneralDialog
      open={props.isOpen}
      handleConfirm={props.onDialogConfirm}
      handleClose={props.onDialogCancel}
      disableBackdropClick
      maxWidth="sm"
      fullWidth
      title="form-builder.share.access-setting.title"
    >
      <Container>
        <BombaButton
          startIcon={<LockIcon />}
          variant="outlined"
          onClick={() => props.onFormTypeBtnClick(FORM_TYPE.REQUIRES_SIGN_IN)}
          color={
            props.formType === FORM_TYPE.REQUIRES_SIGN_IN
              ? 'primary'
              : undefined
          }
        >
          <ButtonGrid>
            <b>
              {t('form-builder.share.access-setting.button.internal.title')}
            </b>
            <small>
              {t('form-builder.share.access-setting.button.internal.text')}
            </small>
          </ButtonGrid>
        </BombaButton>
        <BombaButton
          startIcon={<PublicIcon />}
          variant="outlined"
          onClick={() => props.onFormTypeBtnClick(FORM_TYPE.PUBLIC)}
          color={props.formType === FORM_TYPE.PUBLIC ? 'primary' : undefined}
        >
          <ButtonGrid>
            <b>
              {t('form-builder.share.access-setting.button.external.title')}
            </b>
            <small>
              {t('form-builder.share.access-setting.button.external.text')}
            </small>
          </ButtonGrid>
        </BombaButton>
        <Divider />
        <DisableWrapper $disabled={props.formType === FORM_TYPE.PUBLIC}>
          {/* <H2>{t('form-builder.share.access-setting.title')}</H2> */}
          <LimitAccessSpan>
            <Checkbox
              color="primary"
              checked={props.isLimitAccessChecked}
              onChange={props.onLimitAccessCheckboxToggle}
            />
            <ButtonGrid>
              <b>
                {t(
                  'form-builder.share.access-setting.limit-access-checkbox.text'
                )}
              </b>
              <small>
                {t(
                  'form-builder.share.access-setting.limit-access-checkbox.sub-text'
                )}
              </small>
            </ButtonGrid>
          </LimitAccessSpan>

          <Animation type="collapse" in={props.isLimitAccessChecked}>
            <Select
              value={props.limitAccessGroups}
              options={props.groups || []}
              isMulti
              menuPosition="fixed"
              onChange={props.onLimitAccessDDChange}
              components={{
                MultiValue,
                valueContainer: InputBase,
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              noOptionsMessage={e =>
                e.inputValue
                  ? t('form-builder.share.limit-access.select.no-results')
                  : null
              }
              placeholder={t(
                'form-builder.share.limit-access.select.placeholder'
              )}
            />
          </Animation>

          {props.externalUsersLicense && (
          <LimitAccessSpan>
            <Checkbox
              color="primary"
              checked={props.isAllowExternalChecked}
              onChange={props.onAllowExternalCheckboxToggle}
            />
            <ButtonGrid>
              <b>
                {t(
                  'form-builder.share.access-setting.allow-external-checkbox.text'
                )}
              </b>
              <small>
                {t(
                  'form-builder.share.access-setting.allow-external-checkbox.sub-text'
                )}
              </small>
            </ButtonGrid>
          </LimitAccessSpan>
          )}
        </DisableWrapper>
      </Container>
    </GeneralDialog>
  );
};

export default FormBuilderShareAccessSettingsDialogView;
